export const environment = {
  baseUrl: 'http://localhost:4200',
  dglAuthenApiBaseUrl: 'https://extgw-dgl-pt-uat.arisetech.dev/',
  dglApiBaseUrl: 'https://extgw-dgl-pt-uat.arisetech.dev/',
  production: false,
  mode: 'uat',
  version: '0.3.6',
  tagId: true,
  noCache: true,
  callDglAws: true,
  dglAwsBaseUrl: 'https://extgw-dg-lending-aws-th-uat.arisetech.dev',
  miniAppUUID: '62a2fd5f-f597-49ee-84f2-e061fea9209d',
};
